// reactstrap components
import { Container, Row } from "reactstrap";
// core components
import Header from "../../../components/Headers/Header.js";
import PersonalSurveyList from "../../../components/PersonalSurveyList.js";

const SurveyListing = () => {
  return (
    <>
      <Header
        title="Surveys"
        description="This is your survey list. You manage your surveys here."
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            {/* <h1>User's Surveys</h1> */}
            <PersonalSurveyList />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default SurveyListing;
